angular.module('qkr').controller('finance1CategoryController', finance1CategoryController);
function finance1CategoryController($routeSegment, inventoryService, merchantService, reportService, gettextCatalog,
                                    productList, merchantInfo, APP_CONSTANT,
                                    subscriptionService, messageService, $log) {
      const vm = this;
      vm.accountancySettingsForm = {};
      vm.showCustomerAccountNumber = false;

      vm.showAccountancyCodesInReport = false;

      vm.overTheCounterItems = [];
      vm.invoiceItems = [];
      vm.foodItems = [];
      vm.uncategorizedItems = [];
      vm.updatedItems = [];
      const NON_INVOCE_FOOD_ACC_LEDGER_CODE = 'SC';
      const INVOICE_ACC_LEDGER_CODE = 'DS';
      const NON_INVOICE = 'NON_INVOICE';
      const ACC_GL_CODE = '.6101.RS601';

      vm.init = function() {
        vm.$routeSegment = $routeSegment;
        vm.overTheCounterItems = [];
        vm.invoiceItems = [];
        vm.foodItems = [];
        vm.uncategorizedItems = [];
        for (let i = 0; i < productList.length; ++i) {
          const item = productList[i];
          if (item.accType === NON_INVOICE) {
              vm.overTheCounterItems.push(item);
          } else if (item.accType === APP_CONSTANT.INVOICE) {
              vm.invoiceItems.push(item);
          } else if (item.accType === APP_CONSTANT.FOOD) {
              item.accGlCode = merchantInfo.merchantRegistrationId + ACC_GL_CODE;
              vm.foodItems.push(item);
          } else {
              vm.uncategorizedItems.push(item);
          }
        }
        subscriptionService.executeAction(APP_CONSTANT.SubscriptionService.ACCOUNTANCY_FINANCE1_PRODUCTS_COUNT,
            vm.uncategorizedItems.length);
        vm.accountancySettingsForm.billerCode = merchantInfo.options.billerCode;
        vm.merchantRegistrationId = merchantInfo.merchantRegistrationId;
        vm.showCustomerAccountNumber = reportService.isSynergeticType(
          merchantInfo.accountancyPackage.name
        );
        vm.accountancySettingsForm.customerAccountNumber = merchantInfo.options.customerAccountNumber;
        vm.accountancySettingsForm.showAccountancyCodesInReport = merchantInfo.options.showAccountancyCodesInReport;
      };

      vm.setOverTheCounter = function(item) {
        item.accType = NON_INVOICE;
        item.accTypeDisplay = gettextCatalog.getString('Non-invoice');
        vm.updatedItems.push(item);
      };

      vm.setFood = function(item) {
        item.accType = APP_CONSTANT.FOOD;
        item.accTypeDisplay = gettextCatalog.getString('Food');
        vm.updatedItems.push(item);
      };

      vm.setInvoice = function(item) {
        item.accType = APP_CONSTANT.INVOICE;
        item.accTypeDisplay = gettextCatalog.getString('Invoice');
        vm.updatedItems.push(item);
      };

      vm.updateSettings = function() {
        merchantService
          .updateAccountancySettings(vm.accountancySettingsForm)
          .then(() => {
            reloadRoute();
              messageService.saveAlert();
          }).catch($log.error);
      };

      const resultUpdateAccTypes = () => {
          reloadRoute();
          messageService.saveAlert();
      };

      vm.saveChanges = function() {
          prepareFinance1Data(vm.uncategorizedItems);
          inventoryService.saveAccountancyChanges(vm.uncategorizedItems)
              .then(() => inventoryService.updateAccTypes(vm.updatedItems))
            .then(resultUpdateAccTypes).catch($log.error);
      };

    vm.saveInvalidAccountancy = function(finance1Form,items) {
        finance1Form.$setSubmitted();

        if(finance1Form.$invalid) {
            messageService.warning(gettextCatalog.getString('Please fix the validation error before saving changes'));
            return;
        }
        inventoryService.saveAccountancyChanges(items).then(() => {
            inventoryService.invalidateCache();
            messageService.saveAlert();
        }).then(loadInventory).catch($log.error);
    };


      vm.saveAccountancyChanges = function(items) {
            inventoryService.saveAccountancyChanges(items).then(() => {
                inventoryService.invalidateCache();
                messageService.saveAlert();
            }).then(loadInventory).catch($log.error);
      };


      vm.resetToUnCategorized = function(item) {
        inventoryService.resetToUnCategorized(item).then(() => {
          inventoryService.invalidateCache();
          messageService.saveAlert();
        }).then(loadInventory).catch($log.error);
      };

      function loadInventory () {
          inventoryService.loadInventory().then(() => {
              reloadRoute();
            }).catch($log.error);
      }

      vm.init();

    function reloadRoute() {
        $routeSegment.chain[0].reload();
    }

    function prepareFinance1Data(items) {
        items.map(item => {
            item.accLedgerCode = item.accType === APP_CONSTANT.INVOICE ? INVOICE_ACC_LEDGER_CODE : NON_INVOCE_FOOD_ACC_LEDGER_CODE;
            return false;
        })
    }

}



// WEBPACK FOOTER //
// ./src/finance1/controllers/finance1.category.controller.js